module.exports = __webpack_public_path__ + "static/media/InstrumentSans-Regular.626595c2.woff2";